import React from 'react';
import { useIntl } from 'react-intl';
import { SchemaRenderer } from 'volto-fzj-internet/components';

import { HighlightSchema } from './schema';

const HighlightData = (props) => {
  const { block, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = HighlightSchema({ ...props, intl });

  return (
    <SchemaRenderer
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default HighlightData;
